import { config } from '@/config/config';
import { api } from '@/shared/services/baseApiClient';

import urljoin from 'url-join';
import { ContactProfileApiResponse } from '../models/contactProfile';
import { ConversationMessageApiResponse } from '../models/conversation-message';

class ConversationApi {
  private readonly API_VERSION = 'v1';

  public getContactProfile(workspaceId: string, contactId: string): Promise<ContactProfileApiResponse> {
    const url = urljoin(config().messagingHost, this.API_VERSION, 'workspaces', workspaceId, 'contacts', contactId);
    return api.send('GET', url);
  }

  public getConversationMessages(workspaceId: string, conversationId: string): Promise<ConversationMessageApiResponse> {
    const url = urljoin(
      config().messagingHost,
      this.API_VERSION,
      'workspaces',
      workspaceId,
      'conversations',
      conversationId,
      'messages',
    );
    return api.send('GET', url);
  }
}

export const conversationApi = new ConversationApi();
